var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceIconGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.308,
    height: 12.938,
    viewBox: "0 0 13.308 12.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Device",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(2.629 2.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M30.791,22.1h-5.34A1.452,1.452,0,0,0,24,23.551v5.34a1.452,1.452,0,0,0,1.451,1.451h5.34a1.452,1.452,0,0,0,1.451-1.451v-5.34A1.452,1.452,0,0,0,30.791,22.1Zm.233,5.723a1.315,1.315,0,0,1-1.314,1.314h-3.19A1.315,1.315,0,0,1,25.2,27.823v-3.19a1.315,1.315,0,0,1,1.314-1.314h3.19a1.315,1.315,0,0,1,1.314,1.314Z",
    transform: "translate(-24 -22.1)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M42.224,36.7h-3.19a.535.535,0,0,0-.534.534v3.19a.535.535,0,0,0,.534.534h3.19a.535.535,0,0,0,.534-.534v-3.19A.535.535,0,0,0,42.224,36.7Zm-2.547,1.6a.507.507,0,0,1,0-1.013A.507.507,0,0,1,39.677,38.3Zm1.972,2.191a.507.507,0,0,1,0-1.013A.507.507,0,0,1,41.649,40.492Z",
    transform: "translate(-36.515 -34.701)",
    fill: "#393939"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(4.094 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 0.78,
    height: 1.602,
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 0.78,
    height: 1.602,
    transform: "translate(1.451)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 0.78,
    height: 1.602,
    transform: "translate(2.903)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 0.78,
    height: 1.602,
    transform: "translate(4.34)",
    fill: "#393939"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(4.094 11.336)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 0.78,
    height: 1.602,
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 0.78,
    height: 1.602,
    transform: "translate(1.451)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 0.78,
    height: 1.602,
    transform: "translate(2.903)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 0.78,
    height: 1.602,
    transform: "translate(4.34)",
    fill: "#393939"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(11.706 3.916)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 1.602,
    height: 0.78,
    transform: "translate(0 4.34)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 1.602,
    height: 0.78,
    transform: "translate(0 2.889)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 1.602,
    height: 0.78,
    transform: "translate(0 1.438)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 1.602,
    height: 0.78,
    fill: "#393939"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(0 3.916)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 1.602,
    height: 0.78,
    transform: "translate(0 4.34)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 1.602,
    height: 0.78,
    transform: "translate(0 2.889)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 1.602,
    height: 0.78,
    transform: "translate(0 1.438)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 1.602,
    height: 0.78,
    fill: "#393939"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceIconGray);
export default __webpack_public_path__ + "static/media/DeviceIconGray.05693d11b76b22903f1621f893a0cfb2.svg";
export { ForwardRef as ReactComponent };